<template>
  <div class="main-view">
    <el-radio-group v-model="table.params.status" class="tabsWrap" @change="handleTabs">
      <el-radio-button :label="1">待录单({{ table.num1 }})</el-radio-button>
      <el-radio-button :label="4">录单完成({{ table.num4 }})</el-radio-button>
      <el-radio-button :label="5">已退货({{ table.num5 }})</el-radio-button>
      <el-radio-button :label="2">已关闭({{ table.num2 }})</el-radio-button>
    </el-radio-group>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="采购单号" prop="order_no">
          <el-input
            size="mini"
            v-model.trim="table.params.order_no"
            placeholder="请输入"
            clearable
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品名称" prop="goods_name">
          <el-input
            size="mini"
            v-model.trim="table.params.goods_name"
            placeholder="请输入"
            clearable
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="交货日期" prop="delivery_date">
          <el-date-picker
            v-model="table.params.delivery_date"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
             @change="onSearch">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="收货完成日期" prop="date" v-if="table.params.status == 4">
          <el-date-picker
            v-model="table.params.date"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
             @change="onSearch">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="退货日期" prop="refund_date" v-if="table.params.status == 5">
          <el-date-picker
            v-model="table.params.refund_date"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
             @change="onSearch">
          </el-date-picker>
        </el-form-item>
        <!-- 超级管理员才有地区查询条件 -->
        <el-form-item label="地区" prop="area" v-if="roleType == 1">
          <el-cascader
            v-model="table.params.area"
            :options="areaArr"
            :props="{ checkStrictly: true }"
            clearable
            filterable
            style="width:100%;"
             @change="onSearch">
          </el-cascader>
        </el-form-item>
        <el-form-item label="客户名称" prop="merchant_id">
          <el-select v-model="table.params.merchant_id" filterable placeholder="请选择" clearable @focus="getMerchantSel" @change="changeMerchant">
            <el-option
              v-for="item in merchantArr"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="食堂名称" prop="address_id">
          <el-select v-model="table.params.address_id" filterable placeholder="请输入" clearable @focus="getStoreSel" @change="onSearch">
            <el-option v-for="item in storeArr" :key="item.id" :label="item.name" :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">({{ item.merchant_name }})</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商/采购员" prop="supplier_arr">
          <el-cascader
            v-model="table.params.supplier_arr"
            :options="supplierArrCascader"
            @change="changeSupplierId"
            :props="{checkStrictly: true}"
            filterable
            clearable
            ></el-cascader>
        </el-form-item>
        <el-form-item label="采购状态" prop="is_send" v-if="table.params.status == 1">
          <el-select v-model="table.params.is_send" filterable id="is_send" clearable placeholder="请输入" @change="onSearch">
            <el-option label="已发货" :value="1" ></el-option>
            <el-option label="待发货" :value="2" ></el-option>
            <el-option label="部分收货" :value="3" ></el-option>
            <!-- <el-option label="验收完成" :value="5" ></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
          <el-button icon="el-icon-refresh-right" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="btnAdd">
        <el-button :size="subUnitSize" type="primary" icon="el-icon-plus" @click="handleAdd">添加采购单</el-button>
        <!-- 已关闭的不可以导出 -->
        <el-button
          v-if="table.params.status == 1 || table.params.status == 4"
          :size="subUnitSize"
          type="primary"
          plain
          @click="mergeexportData('/admin/purchase_order/mergeExport')"
          >合并导出</el-button
        >
        <el-button
          v-if="table.params.status == 5"
          :size="subUnitSize"
          type="primary"
          plain
          @click="exportDataRefund('/admin/purchase_order/refundDownload')"
          >导出</el-button
        >
        <el-button v-if="table.params.status != 5" :size="subUnitSize" type="primary" plain @click="batchReceive">批量录单</el-button>
        <el-button v-if="table.params.status != 2 && table.params.status != 5" :size="subUnitSize" type="primary" plain @click="batchPrint">批量打印</el-button>
        <el-button v-if="table.params.status == 4" :size="subUnitSize" type="primary" plain @click="batchPrice">批量改价</el-button>
        <el-button v-if="table.params.status == 1" :size="subUnitSize" type="primary" plain @click="importPriceFun">导入单价
          <el-popover
            placement="top"
            title=""
            width="300"
            trigger="hover"
            content="导入单价可以将某期间待录单的所有采购单内针对某供应商的某商品规格统一填入采购单价，导入成功后再去操作录单时可免输单价。">
             <i class="el-icon-warning" slot="reference" style="color:#e6a23c;"></i>
          </el-popover>
        </el-button>
      </div>
    </div>
    <VTable
      has-pagionation
      :field="toStr({1:field,4:field2,2:field3,5:field5},table.params.status)"
      :loading="table.loading"
      :data="table.data"
      :page='table.params.page'
      :pageSize='table.params.count'
      :total='table.total'
      :tree-props="{children: 'children', hasChildren: 'has_child'}"
      :hasPagionation="true"
      :default-expand-all="false"
      :showSelect="true"
      :updateKey="updateKey"
      :showExpand="table.params.status == 5"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:expand="{row}">
        <el-table :data="row.details">
          <el-table-column align="center"  type="index" width="55" label="明细">
          </el-table-column>
          <el-table-column align="center"  prop="goods_name"  label="商品名称">
            <template slot-scope="scope">
              <div>{{ `${scope.row.goods_name} (${scope.row.unit_name}/${scope.row.spec_name})` }}</div>
              <!-- <div>{{scope.row.merchant_name}}</div> -->
              <div>{{scope.row.address_name?`（${scope.row.address_name}）`:''}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center"  prop="last_purchase_price"  label="采购单价">
            <template slot-scope="scope">
              <span>¥{{scope.row.last_purchase_price}}/{{scope.row.unit_name}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center"  prop="refund_num"  label="退货数量">
            <template slot-scope="scope">
              <span>{{scope.row.refund_num}}{{scope.row.unit_name}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center"  prop="refund_money"  label="退货金额">
            <template slot-scope="scope">
              <span>¥{{scope.row.refund_money}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center"  prop="refund_reason"  label="退货原因">
          </el-table-column>
          <el-table-column align="center"  prop="refund_time"  label="退货时间">
          </el-table-column>
          <el-table-column align="center"  prop="refund_name"  label="操作人">
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:refund_num="{row}">
        <span>{{row.refund_num}}</span>
      </template>
      <template v-slot:refund_money="{row}">
        <span>¥{{row.refund_money}}</span>
      </template>
      <!-- 采购单号 -->
      <template v-slot:order_no="{row}">
        <el-link type="primary" @click="showDetail(row)">{{row.order_no}}</el-link>
      </template>
      <template v-slot:source="{row}">
        <span>{{row.source == 1 ? '销售订单' : '平台自采'}}</span>
      </template>
      <!-- 订单状态 -->
      <template v-slot:distr_status="{row}">
        <span>{{ toStr({0:'待分拣', 1:'待配送', 2:'待送达', 3:'已完成', 4:'已取消'},row.order.status)}}</span>
      </template>
      <!-- status：采购状态 -->
      <template v-slot:status="{row}">
        <span>{{ toStr({0:'待发货',1:'待收货', 2:'已关闭', 3:'部分收货', 4:'全部收货',},row.status)}}</span>
      </template>
      <!-- 验收状态 -->
      <template v-slot:accept_status="{row}">
        <span>{{ toStr({0:'未验收',1:'部分验收', 2:'全部验收', },row.accept_status)}}</span>
      </template>
      <!-- 计划交货日期,待收货可以修改其他日期 -->
      <template v-slot:delivery_date="{row,$index}">
        <span v-if="table.params.status > 1">{{row.delivery_date}}</span>
        <el-popover
          v-else
          :ref="`popoverDom+${$index}`"
          placement="bottom"
          width="220"
          trigger="click">
          <el-form
            class="staff-from"
            :model='form2.data'
          >
            <el-form-item label="修改交货日期" prop="delivery_date">
              <el-date-picker
                v-model="form2.data.delivery_date"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <el-row type="flex" justify="center">
            <el-button type="primary" :loading="form2.loading" :disabled="form2.loading" @click="handleDate(row,$index)">确定</el-button>
          </el-row>
          <el-button slot="reference" type="text" style="color:#409eff" icon="el-icon-edit-outline">{{row.delivery_date}}</el-button>
        </el-popover>
      </template>
      <template v-slot:action="{row}">
        <!-- 待发货的可以关闭、编辑和修改供应商（待收货也加编辑操作），发货了就不能关闭，编辑和修改供应商 -->
        <template v-if="row.status == 0 || row.status == 1">
          <el-button type="text" @click="showEdit(row)">编辑</el-button>
        </template>
        <!-- 待收货和待发货没有录单按钮 -->
        <!-- inventory_check 没审核入库:0 审核入库:1 -->
        <el-button type="text" v-if="row.inventory_check === 0" @click="warehousing(row)">入库</el-button>
        <el-button type="text" v-if="row.accept_status != 0 && table.params.status==1 && row.inventory_check != 0" @click="showReceive(row)">录单</el-button>
        <el-button type="text" v-if="row.status > 2" @click="plexportDataGoods(row)">导出</el-button>
        <!-- <el-button type="text" v-if="row.status != 2" @click="handleShare(row)" :loading="loading">分享</el-button> -->
        <el-button type="text" @click="handleAdd(row)" v-if="row.status > 1">复制</el-button>
        <el-button type="text" @click="showRejected(row)" v-if="row.status == 4">退货</el-button>
        <el-button type="text" @click="handlePrint(row)" v-if="table.params.status != 2">打印标签</el-button>
        <el-dropdown @command="handleCommand($event,row)" style="margin-left:10px" v-if="getdropdown(row)">
          <span class="el-dropdown-link">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="share" v-if="row.status != 2">分享</el-dropdown-item>
              <el-dropdown-item command="export" v-if="row.status == 0 || row.status == 1">导出</el-dropdown-item>
              <el-dropdown-item command="copy" v-if="row.status == 0 || row.status == 1">复制</el-dropdown-item>
              <el-dropdown-item command="supplier" v-if="row.status == 0 || table.params.status == 4">修改供应商</el-dropdown-item>
              <el-dropdown-item command="cancel" v-if="row.status == 0">关闭</el-dropdown-item>
              
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </VTable>

    <!-- 批量收货 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleForm"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      center>
      <el-alert
        title="提示：您可将同一供应商同一天交货日期且未完成收货的采购单一起登记录单"
        type="warning"
        style="margin-bottom:20px;"
        :closable="false">
      </el-alert>
      <el-form
        class="staff-from"
        v-loading="loading"
        element-loading-text="加载中…"
        ref='elFormDom'
        label-position='right'
        label-width="100px"
        :model='form.data'
        :rules='form.rules'
        :size="subUnitSize"
      >
        <el-form-item label="供应商" prop="supplier_id">
          <el-select v-model.trim="form.data.supplier_id" filterable clearable placeholder="请输入">
            <el-option v-for="item in supplierArr" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交货日期" prop="delivery_date">
          <el-date-picker
            v-model="form.data.delivery_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-row type="flex" justify="center">
          <el-button type="primary" :loading="form.loading" :disabled="form.loading" @click="confirm">开始录单</el-button>
        </el-row>
      </template>
    </el-dialog>
    <!-- 批量打印提示弹窗 -->
    <el-dialog
      title="确认打印标签吗？"
      :visible.sync="dialogVisiblePrint"
      width="450px"
      :before-close="handleClosePrint"
      center
    >
      <!-- 批量打印 提示 -->
      <template v-if="batchPrintData.length > 0 && !!is_batch">
        <div style="margin-bottom: 10px">
          <span>订单数量：</span>
          <span style="font-weight: bold">{{ multipleSelection.length }}</span>
        </div>
        <div>
          标签数量：
          <span style="font-weight: bold">{{ batchPrintData.length }}</span>
        </div>
      </template>
      <!-- 单条打印 提示  -->
      <template v-else>
        <div style="margin-bottom: 10px">
          采购单号：<span style="font-weight: bold">{{
            currRow.order_no
          }}</span>
        </div>
        <div>
          标签数量：
          <span style="font-weight: bold">{{ batchPrintData.length }}</span>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          v-print="'myPrintBatch'"
          @click="handlePrintbatchFun"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加采购单 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleForm1"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      center>
      <el-form
        class="staff-from"
        v-loading="loading"
        element-loading-text="加载中…"
        ref='elFormDom1'
        label-position='right'
        label-width="100px"
        :model='form1.data'
        :rules='form1.rules'
        :size="subUnitSize"
      >
        <el-form-item label="供应商" prop="supplier_str">
          <el-select v-model.trim="form1.data.supplier_str" value-key="id" filterable clearable placeholder="请输入">
            <el-option v-for="item in supplierArr" :label="item.name" :value="item" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购来源" prop="source">
          <el-radio-group v-model="form1.data.source" v-removeAriaHidden>
            <el-radio :label="1">销售订单</el-radio>
            <el-radio :label="2">平台自采</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-row type="flex" justify="center">
          <el-button type="primary" :loading="form1.loading" :disabled="form1.loading" @click="showAdd">确认</el-button>
        </el-row>
      </template>
    </el-dialog>

    <!-- 批量打印区域 -->
    <div id="myPrintBatch" ref="myPrintBatch">
      <div
        class="printContent"
        style="padding: 4px 20px"
        v-for="(item, index) in batchPrintData"
        :key="index"
      >
        <div class="print-title" style="margin-top: 4px">
          {{ item.supplier_name }}
        </div>
        <div class="print-flex">
          <div class="print-flex-main">
            <div class="print-con">
              <div>{{ item.goods_name }}</div>
              <div class="print-text">{{item.spec_name}}</div>
            </div>
            <div class="print-con">
              下单数量：{{ item.num  }}{{ item.unit_name }}
            </div>
            <div class="print-con">
              记账数量：{{ getdelivery_num(item) }}{{ (getdelivery_num(item)|| getdelivery_num(item)===0)?item.unit_name:'' }}
              {{Number(item.cov_times)?`${(item.delivery_num/item.cov_times).toFixed(2)}(${item.cov_unit})`:''}}
            </div>
          </div>
          <div>
            <div  ref="qrCodeUreBatch"></div>
          </div>
        </div>
        <div
          class="print-text"
          style="text-align: right; margin-top: 2px;margin-bottom: 2px;"
        >
          {{ $moment(new Date()).format("yyyy-MM-DD HH:mm:ss") }}
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <add ref="add" @refresh="getTable"></add>
    <!-- 编辑 -->
    <edit ref="edit" @refresh="getTable"></edit>
    <!-- 采购单详情 -->
    <detail ref="detail" @refresh="getTable"></detail>
    <!-- 收货 -->
    <receive ref="receive" @refresh="getTable"></receive>
    <!-- 退货 -->
    <reject ref="reject" @refresh="getTable"></reject>
    <!-- 修改供应商 -->
    <supplier-edit
      ref="supplierEdit"
      :setDataApi="setDataApi"
      @refresh="getTable"
    ></supplier-edit>
    <importPrice ref="importPriceRef" :exapleExcel="exapleExcel"></importPrice>
    <!-- 批量改价 -->
    <batchEditPrices @refresh="getTable" ref="batchEditPriceRef"></batchEditPrices>
   <el-dialog
      title="入库审核"
      :visible.sync="storeForm.dialogVisibleStore"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :before-close="handleCloseStore"
      center>
      <div style="text-align: center;">
        <el-radio-group v-model="storeForm.status">
          <el-radio-button :label="2">拒绝入库</el-radio-button>
          <el-radio-button :label="1">同意入库</el-radio-button>
        </el-radio-group>
      </div>
    <template #footer>
        <el-row type="flex" justify="center">
          <el-button type="primary" :loading="storeForm.loading" :disabled="storeForm.loading" @click="saveStore">确认</el-button>
        </el-row>
    </template>
   </el-dialog>
  </div>
</template>

<script>
import Add from './components/Created.vue'
import Edit from './components/Edit.vue'
import Detail from './components/Details.vue'
import Receive from './components/Receive.vue'
import importPrice from './components/ImportPrices.vue'
// import Receive from './components/Untitled.vue'
import Reject from './components/Reject.vue'
import SupplierEdit from '@/components/SupplierEdit.vue'
import VTable from '@/components/VTable';
import { mixinTable } from '@/mixins/table.js'
import { mapGetters } from 'vuex'
import { getStorage } from '@/storage'
import { v4 as uuid } from "uuid";
import QRCode from "qrcodejs2";
import batchEditPrices from './components/batchEditPrices.vue';
export default {
  name: 'PurchaseIndex',
  components: {
    Edit,
    Add,
    Detail,
    Receive,
    Reject,
    SupplierEdit,
    VTable,
    batchEditPrices,
    importPrice
  },
  mixins: [mixinTable],
  computed:{
    ...mapGetters(['goodsTypeArr','areaArr'])
  },
  data() {
    return {
      storeForm:{
        dialogVisibleStore:false,
        loading:false,
        id:'',
        status:'',
        stash_id:'',
      },
      setDataApi: '/admin/purchase_order/updateBuyer', // 修改供应商接口
      fileUrl: 'https://element.eleme.cn/#/zh-CN/component/form#form-item-methods',
      roleType: getStorage('role_type'),// 1:超级管理员，2:管理员, 3：员工
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      loading: false,
      field: [
        { name: "id", label: "ID", width:'80', hidden: false },
        { name: "supplier_name", label: "供应商名称", width:'145', hidden: false },
        { name: "order_no", label: "采购单号", width:'190', hidden: false },
        { name: "source", label: "采购来源", width:'120', showTooltip: true, hidden: false},
        { name: "order_count", label: "商品项数/项", hidden: false},
        { name: "num", label: "下单数量", hidden: false},
        { name: "delivery_date", label: "计划交货日期", width:'120',  hidden: false},
        { name: "accept_num", label: "验收数量", hidden: false},
        { name: "delivery_num", label: "已记账数量", hidden: false},
        { name: "delivery_money", label: "已记账金额", hidden: false},
        { name: "status", label: "采购状态", hidden: false},
        { name: "accept_status", label: "验收状态", hidden: false},
        { name: "city_name", label: "所属地区", hidden: false},
        { name: "create_time", label: "创建时间",  width:'160', hidden: false},
        { name: "action", label: "操作",width: "220", fixed:"right", hidden: false }
      ],
      field2: [
        { name: "id", label: "ID", width:'80', hidden: false },
        { name: "supplier_name", label: "供应商名称", width:'145', hidden: false },
        { name: "order_no", label: "采购单号", width:'190', hidden: false },
        { name: "source", label: "采购来源", width:'120', showTooltip: true, hidden: false},
        { name: "order_count", label: "商品项数/项", hidden: false},
        { name: "num", label: "下单数量", hidden: false},
        { name: "delivery_date", label: "计划交货日期", width:'120',  hidden: false},
        { name: "accept_num", label: "验收数量", hidden: false},
        { name: "delivery_num", label: "已记账数量", hidden: false},
        { name: "delivery_money", label: "已记账金额", hidden: false},
        { name: "status", label: "采购状态", hidden: false},
        { name: "accept_status", label: "验收状态", hidden: false},
        { name: "city_name", label: "所属地区", hidden: false},
        { name: "create_time", label: "创建时间",  width:'160', hidden: false},
        { name: "complete_time", label: "完成时间",  width:'160', hidden: false},
        { name: "action", label: "操作",width: "260", fixed:"right", hidden: false }
      ],
      field3: [
        { name: "id", label: "ID", width:'80', hidden: false },
        { name: "supplier_name", label: "供应商名称", width:'145', hidden: false },
        { name: "order_no", label: "采购单号", width:'190', hidden: false },
        { name: "source", label: "采购来源", width:'120', showTooltip: true, hidden: false},
        { name: "order_count", label: "商品项数/项", hidden: false},
        { name: "num", label: "下单数量", hidden: false},
        { name: "delivery_date", label: "计划交货日期", width:'110',  hidden: false},
        { name: "delivery_num", label: "已记账数量", hidden: false},
        { name: "delivery_money", label: "已记账金额", hidden: false},
        { name: "status", label: "采购状态", hidden: false},
        { name: "accept_status", label: "验收状态", hidden: false},
        { name: "city_name", label: "所属地区", hidden: false},
        { name: "create_time", label: "创建时间",  width:'160', hidden: false},
        { name: "cancel_time", label: "关闭时间",  width:'160', hidden: false},
        { name: "action", label: "操作",width: "80", fixed:"right", hidden: false }
      ],
      field5: [
        { name: "supplier_name", label: "供应商名称", width:'145',  hidden: false},
        { name: "order_no", label: "采购单号",width:'190', hidden: false},
        { name: "order_count", label: "退货项数", hidden: false},
        { name: "refund_num", label: "退货数量", hidden: false},
        { name: "refund_money", label: "退货金额", hidden: false},
        { name: "source", label: "采购来源", hidden: false},
        { name: "delivery_date", label: "计划交货日期", hidden: false},
        { name: "city_name", label: "所属地区", hidden: false},
        { name: "refund_time", label: "退货更新时间", hidden: false},
      ],
      multipleSelection:[],
      table: {
        loading: false,
        params: {
          order_no: '', // 采购单号
          goods_name: '',
          status: 1, //状态 1:待采购 2:已关闭（已取消） 3:部分收货 4:全部收货（完成）
          delivery_date: '', // 收货日期
          date: '', // 收货完成日期
          refund_date:'', // 退货日期
          address_id: '', // 下单食堂
          supplier_arr:[],
          supplier_id: '', //采购员供应商
          supplier_type: '', // 1:供应商 2：采购员
          area: [],
          province: '',
          city: '',
          page: 1,
          count: 10
        },
        data: [],
        total: 0,
        num1: 0,//待记账数量
        num2: 0, //已关闭数量
        num4: 0, //全部记账数量
        num5: 0,
      },
      merchantArr:[], //客户
      storeArr: [], //食堂
      supplierArr: [], // 供应商列表/采购员
      dialogVisibleForm: false,
      form: {
        loading: false,
        data: {
          supplier_id: '', //供应商
          delivery_date:'', // 交货日期
        },
        rules: {
          supplier_id: [{ required: true, message:'请选择供应商', trigger: ['change','blur'] }],
          delivery_date: [{ required: true, message:'请选择交货日期', trigger: ['change','blur'] }],
        }
      },
      dialogVisibleForm1: false,
      form1: {
        loading: false,
        data: {
          supplier_str: {}, //供应商
          source: 1, //采购来源 1:销售订单 2:平台自采
        },
        rules: {
          supplier_str: [{ required: true, message:'请选择供应商', trigger: ['change','blur'] }],
          source: [{ required: true, message:'请选择采购来源', trigger: ['change','blur'] }],
        }
      },
      form2: {
        loading: false,
        data: {
          delivery_date:'', // 交货日期
        },
      },
      updateKey: new Date()+'',
      supplierArrCascader: [], //供应商/采购员级联列表
      currRow: {}, // 当前行数据
      //打印数据
      batchPrintData:[],
      is_batch:false,
      dialogVisiblePrint:false,
      codeTextUrl:'',
      myUUID: "", // 存放生成的UUID值
      myPrintBatch: {
        id: "myPrintBatch",
        preview: false, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
      },
      exapleExcel: "",
    }
  },
  created() {
    this.getTable();
    this.getSupplierSelCascaderStatus(); // 获取供应商/采购员级联列表
    if (window.location.href.indexOf(".cuntoubao.test") != "-1") {
      this.codeTextUrl =
        "http://h5delivery.cuntoubao.test/#/pages/index/rk"; // 测式服地址
    } else {
      this.codeTextUrl =
        "http://h5delivery.cuntoubao.cn/#/pages/index/rk"; // 正式服地址
    }
  },
  methods: {
    warehousing(row) {
      this.storeForm.id = row.id;
      this.storeForm.stash_id = row.stash_id;
      this.storeForm.dialogVisibleStore = true;
    },
    handleCloseStore() {
      this.storeForm.dialogVisibleStore = false;
      this.storeForm.id = '';
      this.storeForm.status = '';
      this.storeForm.stash_id = '';
    },
    saveStore() {
      if(!this.storeForm.status) {
        this.$message.warning('请选择');
        return
      }
      let params = {
        id:this.storeForm.id,
        status:this.storeForm.status,
        stash_id:this.storeForm.stash_id,
      };
      this.storeForm.loading = true;
      this.$http.post('/admin/purchase_order/checkEntry', params).then(res => {
        if(res.code === 1) {
          this.$message.success('操作成功')
          this.handleCloseStore();
          this.getTable()
        }
      }).finally(() =>{
        this.storeForm.loading = false;
      })
    },
    getTable() {
      let _params = {...this.table.params}
      let _area = this.table.params.area;
      if(_area.length == 1) {
        _params.province = _area[0]
      } else if(_area.length == 2) {
        _params.province = _area[0]
        _params.city = _area[1]
      } else {
        _params.province = '';
        _params.city = '';
      }
      delete _params.area;
      delete _params.supplier_arr;
      this.table.loading = true;
      this.$http.get('/admin/purchase_order/list', {params:_params}).then(res => {
        if(res.code === 1) {
          this.updateKey = new Date()+'';
          this.table.loading = false;
          this.exapleExcel = res.data.file;
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.num1 = res.data.num1;
          this.table.num2 = res.data.num2;
          this.table.num4 = res.data.num4;
          this.table.num5 = res.data.num5;
        }
      })
    },
    reset() {
      this.table.params = {
        order_no: '', // 采购单号
        goods_name: '',
        status: this.table.params.status, //状态 1:待采购 2:已关闭（已取消） 3:部分收货 4:全部收货（完成）
        delivery_date: '', // 收货日期
        date: '', // 收货完成日期
        refund_date: '', // 退货日期
        address_id: '', // 下单食堂
        supplier_arr: [],
        supplier_id: '', //采购员供应商
        supplier_type: '', // 1:供应商 2：采购员
        area: [],
        province: '',
        city: '',
      };
      this.table.params.page = 1;
      this.table.params.count = 10;
      this.getTable();
    },
    
    // 编辑
    showEdit(row) {
      let dom = this.$refs.edit;
      dom.toggle(true)
      if(!!row.id) {
        dom.getDetail(row)
      }
      dom = null
    },
    // 采购单详情
    showDetail(row) {
      let dom = this.$refs.detail;
      dom.toggle(true)
      dom.getDetail({
        ...row,
        canPrint:[1,4].includes(this.table.params.status),
        showUploadBill:this.table.params.status == 4,
        showDeleteBill:this.table.params.status == 1,
      })
      dom = null;
    },
    // 收货
    showReceive(row) {
      // let dom = this.$refs.receive;
      // dom.toggle(true)
      // if(!!row.id) {
      //   dom.getDetail(row)
      // }
      // dom = null;
      // ********************
      // 星号以上是弹窗方式收货，以下是打开路由新页面收货，其收货功能是一样的
      window.open(this.$router.resolve({name: 'Receive',query: {purchase_id: row.id} }).href, '_blank');
    },
    // 退款
    showRejected(row) {
      let dom = this.$refs.reject;
      dom.toggle(true)
      if(!!row.id) {
        dom.getDetail(row)
      }
      dom = null;
    },
    // 修改供应商
    showSupplier(row) {
      let dom = this.$refs.supplierEdit;
      dom.toggle(true);
      dom.getDetail(row, 1); // 传1单条修改供应商/采购员
      dom = null;
    },
    // 取消
    handleCancel(row) {
      this.setConfirm(
        `确认关闭操作？`,
        {  id: row.id },
        "/admin/purchase_order/cancel"
      );
    },
    // 导出
    plexportDataGoods(row) {
      let url = '/admin/purchase_order/download'
      let str = ""
      let obj = {
        id: row.id
      }
      Object.keys(obj).forEach(item => {
          str += `&${item}=${obj[item]}`
      })
      // console.log(`${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`)
      window.open(`${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`)
    },
    // 合并导出
    mergeexportData(url) {
      if (this.multipleSelection.length) {
        this.$confirm('同一个商品/下单单位/规格/供应商（采购员）合并为一行数据', '提示', {
          confirmButtonText: '确认导出',
          cancelButtonText: '取消',
        }).then(() => {
         let purchase_ids = this.multipleSelection.map((item) => {
            return item.id;
          }).join("|");
          let str = ""
          let obj = {
            purchase_ids
          }
          Object.keys(obj).forEach(item => {
              str += `&${item}=${obj[item]}`
          })
          console.log(`${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`)
          window.open(`${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`)

        }).catch(() => {});
      } else {
        this.$message.warning("至少勾选一条数据");
      }
    },
    handleCommand(value,row) {
      console.log(value,"value")
      // return
      if(value == 'copy') { // 复制
        this.handleAdd(row)
      } else if(value == 'supplier') { // 修改供应商
        this.showSupplier(row)
      } else if(value == 'cancel') { // 关闭
        this.handleCancel(row)
      } else if(value == 'export') {
        this.plexportDataGoods(row)
      } else if(value == 'share' ){
        this.handleShare(row);
      }
    },
    // 复制分享
    handleShare(row) {
      // type 2:分享
      this.loading = true;
      this.$http.get('/admin/purchase_order/download',{params:{id:row.id,type:2}}).then(res => {
        if(res.code == 1) {
          console.log(res.data.path_url)
          const urlpath = res.data.path_url;
          this.$copyText(urlpath).then(() => {
            this.$message.success(`已复制${row.supplier_name}${row.delivery_date.replace(/-/g, "")}采购单明细`);
          });
        }
      }).finally(() => {
        this.loading = false;
      })
    },
   
    // 批量收货
    batchReceive() {
      this.dialogVisibleForm = true;
      // this.getSupplierSel(); // 获取供应商采购员
      this.getSupplierSelStatus();
    },
    confirm() {
      this.$refs.elFormDom.validate(valid => {
        if (valid) {
          let _params = {
            delivery_date: this.form.data.delivery_date, // 配送日期
            supplier_id: this.form.data.supplier_id, // 供应商/采购员
          }
          this.$http.get('/admin/purchase_order/infoByBind', { params: _params}).then(res => {
            if(res.code == 1) {
              if(res.data.list.length > 0) {
                let _query = {
                  delivery_date: this.form.data.delivery_date, // 配送日期
                  supplier_id: this.form.data.supplier_id, // 供应商/采购员
                  supplier_name: this.supplierArr.filter(v => v.id == this.form.data.supplier_id)[0].name
                };
                // let statusList = res.data.list.map(item =>item.status);
                // if(statusList.includes(0) || statusList.includes(1)) {
                //   this.$message.warning("所选供应商有单据待收货或待发货，请先处理后再操作");
                //   return
                // }
                window.open(this.$router.resolve({name: 'BatchReceive',query: _query }).href, '_blank');
                setTimeout(() => {
                  this.dialogVisibleForm = false;
                  this.form.data.delivery_date = '';
                  this.form.data.supplier_id = '';
                },100)
              } else {
                this.$message.warning("暂无待收货单据，请检查")
              }
            }
          })
        }
      })
    },
     // 修改计划交货日期
    handleDate(row,index) {
      var then = this;
      if(!this.form2.data.delivery_date) {
        this.$message.warning("请选日期");
        return
      }
      this.$http.post('/admin/purchase_order/editDate', {id:row.id,delivery_date:this.form2.data.delivery_date}).then(res => {
        if(res.code == 1) {
          then.form2.data.delivery_date = '';
          then.$message.success('操作成功！');
          then.$refs[`popoverDom+${index}`].doClose();
          then.$refs.elFormDom.resetFields();
          then.getTable();
        }
      })
    },
    
    handleAdd(row) {
      this.currRow = !!row.id ? {...row} : {};
      this.dialogVisibleForm1 = true;
      this.form1.data.supplier_str = {};
      this.form1.data.source = 1;
      // this.getSupplierSel(); // 获取供应商采购员
      this.getSupplierSelStatus();
    },
    // 新增采购单
    showAdd() {
      this.$refs.elFormDom1.validate(valid => {
        if(valid) {
          this.dialogVisibleForm1 = false;
          let dom = this.$refs.add;
          dom.toggle(true)
          dom.getDetail({...this.currRow,source:this.form1.data.source,supplier_str:this.form1.data.supplier_str})
          dom = null;
        }
      })
    },
    handleClosePrint() {
      this.batchPrintData = [];
      this.is_batch = false; //是否批量打印
      this.dialogVisiblePrint = false;
    },
    handlePrint(row) {
      this.currRow = row;
      this.is_batch = false;
      this.batchPrintData = row.details.map(item => {
        return {
          ...item,
          supplier_name:row.supplier_name,
        }
     }); // 需要打印的数据
      this.dialogVisiblePrint = true;
    },
    batchPrint() {
      if(this.multipleSelection.length) {
        this.multipleSelection.forEach(item =>{
          item.details.forEach(i =>{
            i.supplier_name =item.supplier_name;
          })
        });
        this.batchPrintData = this.multipleSelection.reduce(
           (acc, item) => acc.concat(item.details),
        []); // 需要打印的数据
        this.is_batch = true; //是否批量打印
        this.dialogVisiblePrint = true;
      } else {
        this.$message.warning("至少勾选一条数据");
      }
    },
    handlePrintbatchFun() {
      this.dialogVisiblePrint = false;
      console.log(this.batchPrintData,'batchPrintData');
      this.batchPrintData.forEach((v, i) => {
        this.currPrintObj = v;
        this.myUUID = uuid().replace(/-/g, "/"); // myUUID将字符串中的 '-' 替换成 '/'
        this.$refs["qrCodeUreBatch"][i].innerHTML = ""; //生成二维码之前先清除上一次的
        console.log(`${this.codeTextUrl}?detail_id=${v.id}`);
        new QRCode(this.$refs.qrCodeUreBatch[i], {
          text: `${this.codeTextUrl}?detail_id=${v.id}`,
          width:100,
          height: 100,
          colorDark: "#000",
          colorLight: "#fff",
          correctLevel: QRCode.CorrectLevel.M,
        });
      });
      this.myPrintBatch = {
        id: "myPrintBatch",
        popTitle: "打印", // 打印配置页上方标题
        extraHead: "", //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
        preview: true, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
      };
    },
    getdropdown(row) {
      return row.status != 2 || (row.status == 0 || row.status == 1) || row.status == 0
    },
    getdelivery_num(item) {
      if(Number(item.delivery_num)) {
        return Number(item.delivery_num)
      } else if(!Number(item.delivery_num) &&item.status==1) {
        return ''
      } else {
        item.delivery_num
      }
    },
    exportDataRefund(url) {
      if(this.multipleSelection.length) {
        this.plexportData(url)
      }else {
        this.exportData(url)
      }
    },
    batchPrice() {
      let dom = this.$refs.batchEditPriceRef;
      dom.toggle(true);
    },
    importPriceFun() {
      let dom = this.$refs.importPriceRef;
      dom.toggle(true);
    }
  }
}
</script>


<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  color: #2cb167;
  font-size: 12px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.main-view {
  overflow: auto;
}
.main-view::-webkit-scrollbar {
  width:0px;
}
.main-view::-webkit-scrollbar-thumb {
  background: #8d8d8d;
  border-radius: 0px;
}
</style>
<style media="print" lang="scss">
.printContent {
  display: none;
}
.print-text {
  margin: 0 0.3125rem;
}

@page {
  size: auto;
  // margin: 0 2mm;
}
@media print {
  html {
    background-color: #ffffff;
    height: auto;
    margin: 0;
  }
  body {
    border: solid 0.0625rem #ffffff;
    font-size: 0.625rem;
  }
  body, html, div {
    height: auto !important; /* 确保内容高度自动调整 */
    width: auto !important; /* 确保内容宽度自动调整 */
    page-break-inside: avoid; /* 避免内容被分页拆分 */
  }
  .print-title {
    margin: 0 0.3125rem;
    border-bottom: 0.0625rem solid #000;
    font-size: 1.6rem;
    margin-top: 0.2rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .print-con {
    font-size: 1rem;
  }
  .print-con2 {
    font-size: 0.5rem;
  }
  .print-text {
    font-size: 0.5rem;
  }
  .layout__wrap {
    height: auto !important;
  }
  .main-view {
    height: auto !important;
  }
  .print-flex {
    display: flex;
    justify-content: space-between;
    margin: 0.3125rem;
  }
  .print-flex-main {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .printContent {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.3125rem;
    margin: 0;
  }
}
</style>


